module.exports = __webpack_public_path__ + "img/logo_hextar_correct.460220ad.png";